module.exports = __webpack_public_path__ + "static/media/RaveendraSiriwardana.ec812aa4.jpeg";